// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const SubProductOfferingService = {};

SubProductOfferingService.postSubProductOffering = function (data) {
  // console.log("postSubProductOfferingxte", data.CurrencyID);

  return lossClient({
    url: "/SubProductOffering/add",
    method: "post",
    data: data,
  });
};

SubProductOfferingService.puttSubProductOffering = function (data) {
  // console.log("puttSubProductOffering service id", data.id);
  // console.log("puttSubProductOffering service data", data.data);

  return lossClient({
    url: "/SubProductOffering/edit",
    method: "put",
    headers: {
      "x-RequestId": data.id,
    },
    data: data.data,
  });
};

SubProductOfferingService.deleteProductOfferingCharges = function (data) {
  return lossClient({
    url: "/SubProductOffering/delete",
    method: "delete",
    headers: {
      "x-RequestId": data.id,
    },
    data: {
      UserId: data.userId,
    },
  });
};

SubProductOfferingService.subproductOfferingApproval = function (data) {
  
  return lossClient({
    url: "/SubProductOffering/approve",
    method: "put",
    headers: {
      "x-RequestId": data.id,
    },
    data: {
      Note: data.note,
      UserId: data.userId,
    },
  });
};

SubProductOfferingService.SupplerGroupRequest = function (data) {
  

  return lossClient({
    url: "/SubProductOffering/Request",
    method: "put",
    headers: {
      "x-RequestId": 16,
    },
    data: {
      Request: "S",
      userId: "OpenGea",
    },
  });
};
SubProductOfferingService.ProductOfferingRequest = function (data) {
   

  return lossClient({
    url: "/SubProductOffering/request",
    method: "put",
    headers: {
      "x-RequestId": data.id,
    },
    data: {
      Request: data.Request,
      Note: data.note,
      UserId: data.userId,
    },
  });
};
SubProductOfferingService.productOfferingReturn = function (data) {
  

  return lossClient({
    url: "/SubProductOffering/Return",
    method: "put",
    headers: {
      "x-RequestId": data.id,
    },
    data: {
      Note: data.note,
      UserId: data.userId,
    },
  });
};
SubProductOfferingService.ProductOfferingReject = function (data) {
  

  return lossClient({
    url: "/SubProductOffering/reject",
    method: "put",
    headers: {
      "x-RequestId": data.id,
    },
    data: {
      Note: data.note,
      UserId: data.userId,
    },
  });
};

SubProductOfferingService.getsubproductOfferingApproval = function (userInput) {
  var userInputIndex = userInput.pageIndex || 0;
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  return lossClient({
    url:
      "/SubProductOffering/approvalItems?pageSize="+
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.prodCod,
    method: "get",
  });
};
SubProductOfferingService.getsubproductOffering = function (userInput) {
  var userInputIndex = userInput.pageIndex || 0;
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  // console.log("getsubproductOfferingserveice", userInput.pageSize);
  return lossClient({
    url:
      "/SubProductOffering/items?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.prodCod,
    method: "get",
  });
};
SubProductOfferingService.getSelectSubproductOffering = function (userInput) {
  return lossClient({
    url: "/SubProductOffering/items?pageSize=10000&pageIndex=0",
    method: "get",
  });
};
SubProductOfferingService.getsubproductOfferingSerch = function (data) {
  console.log("tesssoffering", data.name);
  var dataIndex = data.pageIndex || 0;
  var decrementIndex = dataIndex === 0 ? dataIndex : dataIndex - 1;
  
  return lossClient({
    url:
      "/SubProductOffering/search?pageSize=" +
      data.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&subproduct=" +
      data.subproduct +
      "&producttype=" +
      data.producttype +
      "&searchTerm=" +
      data.searchTerm,
    method: "get",
  });
};

SubProductOfferingService.uploadProductOffering = function (data) {
  // console.log("🚀 ~uploadProductFeeCharges data:", data);

  return lossClient({
    url: `/SubProductOffering/upload`,
    method: "post",
    headers: {},
    data: data,
  });
};

export default SubProductOfferingService;
